import { useMemo } from 'react'

import { useFilters, useModals } from '@domain-group/react-hooks'
import type { UseFiltersPayload } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import PageContent from './components/PageContent'

export type PageContextPayload = UseFiltersPayload

const List = () => {
  const filtersPayload = useFilters({ persistFilters: true })
  const {
    callbacks: filterCallbacks,
    defaultFilters,
    defaultFiltersModifiedAt,
    pageFilters,
  } = filtersPayload

  const modalContext = useModals()

  const pageContext = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
    },
    defaultFilters,
  }), [defaultFiltersModifiedAt]) // modalContext dependency required if layering modals

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent pageFilters={pageFilters} />
      </ModalContext.Provider>
    </PageContext.Provider>
  )
}

export default List
